import { useEffect, useLayoutEffect, useRef } from 'react'
import { type DirectionalLight, type Object3D } from 'three'

import { useLevelGeometry, useShadowHelper } from '@hooks'
import { useEnvironmentControls } from '@utils'

// function ShadowDriver() {
//   const { gl } = useThree()
//   const currentLevelIndex = useGameStore(state => state.currentLevelIndex)
//   const dirtyFrames = useRef(2)

//   /* eslint-disable react-hooks/immutability */
//   useEffect(() => {
//     gl.shadowMap.autoUpdate = false
//     return () => {
//       gl.shadowMap.autoUpdate = true
//     }
//   }, [gl])

//   useEffect(() => {
//     dirtyFrames.current = 2
//     gl.shadowMap.needsUpdate = true
//   }, [gl, currentLevelIndex])
//   /* eslint-enable react-hooks/immutability */

//   useFrame(({ gl: frameGl }) => {
//     const { network } = useGameStore.getState()
//     const locoMoving = (network?.locomotive?.currentVelocity ?? 0) !== 0
//     const npcMoving = locoMoving
//       ? false
//       : !!network && Array.from(network.npcs.values()).some(npc => npc.currentVelocity !== 0)

//     const isMoving = locoMoving || npcMoving
//     const forceUpdate = dirtyFrames.current > 0
//     frameGl.shadowMap.needsUpdate = forceUpdate || isMoving
//     if (forceUpdate) dirtyFrames.current -= 1
//   })

//   return null
// }

export function Environment() {
  const {
    shadows,
    bias,
    normalBias,
    helpers,
    padding,
    ambientLightIntensity,
    directionalLightIntensity,
    sunAzimuth,
    sunElevation,
    sunDistance,
  } = useEnvironmentControls()

  const { size } = useLevelGeometry()
  const directionalLightRef = useRef<DirectionalLight>(null!)
  const helperRef = useShadowHelper(directionalLightRef)
  const directionalLightTargetRef = useRef<Object3D>(null!)

  useEffect(() => {
    if (!helperRef.current) return
    helperRef.current.visible = helpers
  }, [helpers, helperRef])

  useLayoutEffect(() => {
    if (!directionalLightRef.current || !directionalLightTargetRef.current) return
    directionalLightRef.current.target = directionalLightTargetRef.current
  }, [])

  useEffect(() => {
    if (!directionalLightRef.current) return

    const azRad = (sunAzimuth * Math.PI) / 180
    const elRad = (sunElevation * Math.PI) / 180
    directionalLightRef.current.position.set(
      sunDistance * Math.cos(elRad) * Math.sin(azRad) + size.centerOffset,
      sunDistance * Math.sin(elRad),
      sunDistance * Math.cos(elRad) * Math.cos(azRad),
    )

    directionalLightRef.current.shadow.camera.top = size.height / 2 + padding
    directionalLightRef.current.shadow.camera.bottom = -size.height / 2 - padding
    directionalLightRef.current.shadow.camera.right = size.visibleWidth / 2 + padding
    directionalLightRef.current.shadow.camera.left = -size.visibleWidth / 2 - padding
    directionalLightRef.current.shadow.camera.updateProjectionMatrix()
    directionalLightRef.current.shadow.bias = bias
    directionalLightRef.current.shadow.normalBias = normalBias
  }, [sunAzimuth, sunElevation, sunDistance, size, bias, normalBias, padding])

  return (
    <>
      <ambientLight intensity={ambientLightIntensity} />

      <directionalLight
        ref={directionalLightRef}
        castShadow={shadows}
        intensity={directionalLightIntensity}
        shadow-mapSize={[256, 256]}
        shadow-radius={3}
        shadow-camera-near={5}
        shadow-camera-far={30}
      />
      <object3D ref={directionalLightTargetRef} position={[size.centerOffset, 0, 0]} />
      {/* <ShadowDriver /> */}
    </>
  )
}
